import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { Discount } from "@/models/discount"

export interface DiscountsInterface {
  list: Discount[]
  selected: Discount
  /** True while the by-restaurant coupons list is being fetched (shared across all hook instances). */
  listLoading: boolean
}

const initialState: DiscountsInterface = {
  list: [],
  selected: {} as Discount,
  listLoading: false,
}

export const discountsSlice = createSlice({
  name: "discounts",
  initialState,
  reducers: {
    updateDiscounts: (state, action: PayloadAction<Partial<DiscountsInterface>>) => {
      if (action.payload.list !== undefined) {
        state.list = action.payload.list
      }
      if (action.payload.selected !== undefined) {
        state.selected = action.payload.selected
      }
      if (action.payload.listLoading !== undefined) {
        state.listLoading = action.payload.listLoading
      }
    },
  },
})

export const { updateDiscounts } = discountsSlice.actions

export default discountsSlice.reducer
